import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/Index'
import User from '@/view/system/user/ZxUserTable'
import Cars from '@/view/system/car/CarsTable'
import CarsInfo from '@/view/system/car/CarsInfo'
import CarsOperateDialog from '@/view/system/car/CarsOperateDialog'
import RepairUsers from '@/view/system/repair/RepairUserTable'
import RepairUserInfo from '@/view/system/repair/RepairUserInfo'
import analyzePh from '@/view/system/analyze/analyzePh'
import analyzeP from '@/view/system/Maintenance/analyzeP'
import analyzeTable from '@/view/system/analyze/analyzeTable'
import analyzeTabl from '@/view/system/Maintenance/analyzeTabl'
import Login from '@/view/Login'
import PrefectureScreen from '@/view/PrefectureScreen/PrefectureScreen'
import PrefectureScreenXZ from '@/view/PrefectureScreen/PrefectureScreenXZ'
import VillagesBCStatistics from '@/view/statistics/VillagesBCStatistics'
import TownsBCStatistics from '@/view/statistics/TownsBCStatistics'
import TownPeopleBCStatistics from '@/view/statistics/TownPeopleBCStatistics'
import GCArchivesInfoTable from '@/view/GCArchivesInfo/GCArchivesInfoTable'
import GCArchivesInfo from '@/view/GCArchivesInfo/GCArchivesInfo'
import VisualizationTable from '@/view/PrefectureScreen/VisualizationTable'
import DataAnalysis from '@/view/DataAnalysis/Index'
import WcAnalysis from '@/view/DataAnalysis/WcAnalysis'
import NoticeTable from '@/view/notice/NoticeTable'
import VillagesBXStatistics from '@/view/statistics/VillagesBXStatistics'
import GCarchivesStatistics from '@/view/statistics/GCarchivesStatistics'
import TownsBXStatistics from '@/view/statistics/TownsBXStatistics'
import TownPeopleBXStatistics from '@/view/statistics/TownPeopleBXStatistics'
import NoticeDetailTable from '@/view/notice/NoticeDetailTable'
import CarsLabor from '@/view/setFunction/CarsTable'
import CarsLaborInfo from '@/view/setFunction/CarsInfo'
import CarsLaborDialog from '@/view/setFunction/CarsOperateDialog'
import RelFlect from '@/view/setFunction/RelFlect'
import SetSwitch from '@/view/setFunction/SetSwitch'
import SatisfactionAnalysis from '@/view/DataAnalysis/SatisfactionAnalysis'
import ControlIndex from '@/view/ControlIndex/index'
import NoticeJs from '@/view/notice/NoticeJs'
import QddManage from '@/view/setFunction/QddManage'
import SbManage from '@/view/setFunction/SbManage'
import satisfactionTable from '@/view/statistics/satisfactionTable'

const VueRouterPush = Router.prototype.push

Router.prototype.push = function push(to) {
    return VueRouterPush.call(this, to).catch((err) => err)
}
Vue.use(Router)
const newRoutes = [
    // {
    //     // 登录
    //     path: '/login',
    //     name: 'Login',
    //     component: Login
    // },
    {
      // 大屏
      path: '/countyControl/prefectureScreen',
      name: 'PrefectureScreen',
      meta: { rank: 2 },
      component: PrefectureScreen,
      children: [{
        // 可视化跳转
        path: '/countyControl/prefectureScreen/visualization',
        name: 'VisualizationTable',
        meta: { rank: 3 },
        component: VisualizationTable
      }]
    },
  {
    // 镇大屏
    path: '/countyControl/prefectureScreenXZ',
    name: 'PrefectureScreenXZ',
    meta: { rank: 2 },
    component: PrefectureScreenXZ,
    children: [{
      // 可视化跳转
      path: '/countyControl/prefectureScreenXZ/visualization',
      name: 'VisualizationTableXZ',
      meta: { rank: 3 },
      component: VisualizationTable
    }]
  },
    {
        // 基本信息
        path: '/',
        name: 'BaseInfo',
        component: Index,
        children: [
            {
                // 抽粪车辆管理
                path: '/cars',
                name: 'Cars',
                meta: { rank: 2 },
                component: Cars,
                children: [{
                        // 抽粪车辆信息
                        path: '/cars/carsInfo',
                        name: 'CarsInfo',
                        meta: { rank: 3 },
                        component: CarsInfo
                    },
                    {
                        // 抽粪车辆管理编辑
                        path: '/CarsOperateDialog',
                        name: 'CarsOperateDialog',
                        meta: { rank: 3 },
                        component: CarsOperateDialog
                    }
                ]
            },
            {
                // 维修人员管理
                path: '/repairUsers',
                name: 'RepairUsers',
                meta: { rank: 2 },
                component: RepairUsers,
                children: [{
                    path: '/repairUsers/repairUserInfo',
                    name: 'RepairUserInfo',
                    meta: { rank: 3 },
                    component: RepairUserInfo
                }]
            }
        ]
    },
    {
        // 管控端
        path: '/',
        name: 'CountyControl',
        component: Index,
        children: [
          {
            // 门户首页
            path: '/countyControl/index',
            name: 'ControlIndex',
            component: ControlIndex
          },
            {
                // 乡镇报抽统计查询
                path: '/villagesBCStatistics',
                name: 'VillagesBCStatistics',
                meta: { rank: 2 },
                component: VillagesBCStatistics,
                children: [{
                        // 村庄报抽统计查询
                        path: '/villagesBCStatistics/townsBCStatistics',
                        name: 'TownsBCStatistics',
                        meta: { rank: 3 },
                        component: TownsBCStatistics,
                        children: [{
                               // 村庄下所有报抽统计查询
                               path: '/villagesBCStatistics/townPeopleBCStatistics.vue',
                               name: 'TownPeopleBCStatistics',
                               meta: { rank: 4 },
                               component: TownPeopleBCStatistics
                         }]
                    },

                ]
            },
            {
                // 乡镇报修统计查询
                path: '/villagesBXStatistics',
                name: 'VillagesBXStatistics',
                meta: { rank: 2 },
                component: VillagesBXStatistics,
                children: [{
                        // 村庄报抽统计查询
                        path: '/villagesBXStatistics/townsBXStatistics',
                        name: 'TownsBXStatistics',
                        meta: { rank: 3 },
                        component: TownsBXStatistics,
                        children: [
                              {
                                // 村庄下所有报抽统计查询
                                path: '/villagesBXStatistics/townPeopleBXStatistics.vue',
                                name: 'TownPeopleBXStatistics',
                                meta: { rank: 4 },
                                component: TownPeopleBXStatistics
                              }
                        ]
                    },

                ]
            },
            {
                // 改厕档案统计查询
                path: '/GCarchivesStatistics',
                name: 'GCarchivesStatistics',
                meta: { rank: 2 },
                component: GCarchivesStatistics,
                children: [{
                        // 村庄报抽统计查询
                        path: '/GCarchivesStatistics/GCTownsStatistics',
                        name: 'GCTownsStatistics',
                        meta: { rank: 3 },
                        component: () => import('@/view/statistics/GCTownsStatistics.vue'),
                        // children: [
                        //       {
                        //         // 村庄下所有报抽统计查询
                        //         path: '/GCarchivesStatistics/GCarchivesStatisticsInfo.vue',
                        //         name: 'GCarchivesStatisticsInfo',
                        //         meta: { rank: 4 },
                        //         component: () => import('@/view/statistics/GCarchivesStatisticsInfo.vue'),
                        //       }
                        // ]
                    },
                    {
                      path: '/GCarchivesStatistics/GCarchivesStatisticsInfo',
                      name: 'GCarchivesStatisticsInfo',
                      meta: { rank: 3 },
                      component: () => import('@/view/statistics/GCarchivesStatisticsInfo.vue'),
                    }

                ]
            },{
                // 统计导出
                path: '/statisticalReport',
                name: 'statisticalReport',
                meta: { rank: 2 },
                component: () => import('@/view/statistics/statisticalReport.vue')
            }, {
                // 用户管理
                path: '/user',
                name: 'User',
                meta: { rank: 2 },
                component: User
            },{
                path: '/logManagement',
                name: 'logManagement',
                meta: { rank: 2 },
                component: () => import('@/view/system/log/logManagement.vue')
            },
            {
                // 开关设置
                path: '/SetSwitch',
                name: 'SetSwitch',
                meta: { rank: 2 },
                component: SetSwitch
            },
            {
                // 车辆分工管理
                path: '/carsLabor',
                name: 'CarsLabor',
                meta: { rank: 2 },
                component: CarsLabor,
                children: [{
                        // 车辆信息查看
                        path: '/carsLabor/carsLaborInfo',
                        name: 'CarsLaborInfo',
                        meta: { rank: 3 },
                        component: CarsLaborInfo
                    },
                    {
                        // 车辆信息编辑
                        path: '/carsLabor/carsLaborEdit',
                        name: 'CarsLaborDialog',
                        meta: { rank: 3 },
                        component: CarsLaborDialog
                    }
                ]
            },
            {
              // 清倒点管理
              path: '/qddManage',
              name: 'QddManage',
              meta: { rank: 2 },
              component: QddManage,
              children: []
            },
            {
              // 清倒点管理
              path: '/sbManage',
              name: 'SbManage',
              meta: { rank: 2 },
              component: SbManage,
              children: []
            },
            {
              // 在线反馈
              path: '/relflect',
              name: 'RelFlect',
              meta: { rank: 2 },
              component: RelFlect,
            },
            {
                // 改厕档案信息
                path: '/gCArchivesInfoTable',
                name: 'GCArchivesInfoTable',
                meta: { rank: 2 },
                component: GCArchivesInfoTable,
                children: [{
                    // 改厕档案信息查看
                    path: '/gCArchivesInfoTable/gCArchivesInfo',
                    name: 'GCArchivesInfo',
                    meta: { rank: 3 },
                    component: GCArchivesInfo
                }]
            },
            {
                // 大数据分析
                path: '/dataAnalysis',
                name: 'dataAnalysis',
                meta: { rank: 2 },
                component: DataAnalysis,
                children: [{
                        // 抽厕分析
                        path: '/dataAnalysis/wcAnalysis',
                        name: 'wcAnalysis',
                        meta: { rank: 3 },
                        component: WcAnalysis
                    },
                    {
                        //维修分析
                        path: '/dataAnalysis/Maintenance',
                        name: 'Maintenance',
                        component: analyzeP,
                        meta: { rank: 3 },
                        children: [{
                            path: '/analyzeTabl',
                            name: 'analyzeTabl',
                            component: analyzeTabl,
                            meta: { rank: 4 }
                        }]
                    },
                    {
                        // 大数据分析
                        path: '/dataAnalysis/SatisfactionAnalysis',
                        name: 'SatisfactionAnalysis',
                        meta: { rank: 3 },
                        component: SatisfactionAnalysis,
                        children: [{
                            path: '/satisfactionTable',
                            name: 'satisfactionTable',
                            component: satisfactionTable,
                            meta: { rank: 4 }
                        }]
                    },
                    {
                        path: '/dataAnalysis/analyze',
                        name: 'analyze',
                        component: analyzePh,
                        meta: { rank: 3 },
                        children: [{
                            path: '/analyzeTable',
                            name: 'analyzeTable',
                            component: analyzeTable,
                            meta: { rank: 4 }
                        }]
                    }
                ]
            },
            {
                // 通知公告
                path: '/notice',
                name: 'Notice',
                meta: { rank: 2 },
                component: NoticeTable,
                children: []
            },
            {
                // 通知公告详情
                path: '/noticeDetail',
                name: 'NoticeDetail',
                meta: { rank: 2 },
                component: NoticeDetailTable,
                children: []
            },
          {
                // 通知接收列表
                path: '/noticeJs',
                name: 'NoticeJs',
                meta: { rank: 2 },
                component: NoticeJs,
                children: []
          }
        ]
    },
    {
        // 工作台
        path: '/',
        name: 'workPlatform',
        component: Index,
        children: [{
            path: '/workbench',
            name: 'workbench',
            meta: { rank: 2 },
            component: () =>
                import ('@/view/Workbench/Index.vue')
        }, {
            path: '/bxManage',
            name: 'bxManage',
            meta: { rank: 2 },
            component: () =>
                import ('@/view/Workbench/bxManage.vue')
        }, {
            path: '/careOf',
            name: 'careOf',
            meta: { rank: 2 },
            component: () => import('@/view/Workbench/careOf.vue')
        }, {
            path: '/BcTable',
            name: 'BcTable',
            meta: { rank: 2 },
            component: () => import('@/view/Workbench/BcTable.vue')
        }, {
            path: '/xcTable',
            name: 'xcTable',
            meta: { rank: 2 },
            component: () => import('@/view/Workbench/xcTable.vue')
        }
        ]
    }
]

export default new Router({
    routes: newRoutes
})



// WEBPACK FOOTER //
// ./src/router/index.js